// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"contactDetailsItem_mulitpleDropdown__1ZErZ","label":"contactDetailsItem_label__1cDui"};